var _g, _rect, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      left: 1,
      top: 1,
      width: 32,
      height: 30,
      display: "block",
      position: "relative",
      overflow: "hidden"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)",
    style: {
      visibility: "visible"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.44,
    y: 7.68,
    width: 28.8,
    height: 14.4,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1.3,
    pointerEvents: "all"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.47a1d08910ada7b87b3472e200a1c164.svg";
export { ForwardRef as ReactComponent };